import { useMutation } from "react-query";
import { communityApi } from "@circle-react/api/communityApi";

export const useUpdateCommunity = (options = {}) => {
  const mutation = async payload => communityApi.update(payload);

  return useMutation(mutation, options);
};
